import {size} from 'lodash';
import {ShapeConstants} from './penpot/constant';
import {generateUUID} from './index';

export const PROP_SUFFIX_CONNECTOR = '__';

// 渲染后才可能重新计算自适应高度的组件类型.
export const FIT_AFTER_RENDER_COMPONENTS = ['text', 'richText','tree-node'];
/**
 * 组装树状的web-component结构
 * @param components
 * @param componentProp
 * @param tree
 * @param status
 */
export const assembleWebComponentTree = (components, componentProp, tree, status = false) => {
  const atom = _cloneDeep(components.find(i => i.prop === componentProp));
  if (atom) {
    Object.keys(atom).forEach(key => {
      tree[key] = atom[key];
    });
    tree.children = [];
    if (status || ((atom.attrs.skeletonScreen && !atom.attrs.skeletonScreen.value) || !atom.attrs.skeletonScreen)) {
      atom.children.forEach(({ prop }) => {
        const subTree = {};
        tree.children.push(subTree);
        assembleWebComponentTree(components, prop, subTree, status);
      });
    }
  }
};


/**
 * 初始化数据ID、数据实例ID、父数据ID、父数据实例ID等
 * @param component
 * @param parent
 * @private
 */
export const initNodeDataIndex = (component, parent?) => {
  //如果父节点是由循环区域生成且不是循环区域本身，则本节点prop同样需要加上后缀
  if ((_get(parent, 'prop', '').indexOf(PROP_SUFFIX_CONNECTOR) !== -1) && (component.prop.indexOf(PROP_SUFFIX_CONNECTOR) === -1)) {
    component.prop = component.prop + PROP_SUFFIX_CONNECTOR + generateUUID();
    if (_get(parent, 'prop')) {
      component.parent =_get(parent, 'prop');
    }
  }
  if (parent) {
    component.dataIndex = parent.dataIndex;
  }
};


/**
 * 计算组件实际位置和组件定义位置之间的偏移量
 * @param component
 * @param componentDef
 * @private
 */
export const calOffset = (component, componentDef) => {
  if (component && componentDef) {
    return {
      offsetX: component.css[ShapeConstants.x] - componentDef.css[ShapeConstants.x],
      offsetY: component.css[ShapeConstants.y] - componentDef.css[ShapeConstants.y],
    };
  } else {
    return {
      offsetX: 0,
      offsetY: 0,
    };
  }
};


/**
 * 根据行列计算循环区域位置
 * @param component
 * @param componentDef
 * @param col
 * @param row
 * @param offset
 * @private
 */
export const calCyclicRegionPosition = (component, componentDef, col, row, offset) => {
  let { offsetX, offsetY } = offset;
  let { marginTop, marginBottom, marginLeft, marginRight } = componentDef.css;
  translateComponent(component,
    {
      offsetX: col * (componentDef.css[ShapeConstants.width] + (marginLeft || 0) + (marginRight || 0)) + offsetX,
      offsetY: row * (componentDef.css[ShapeConstants.height] + (marginTop || 0) + (marginBottom || 0)) + offsetY,
    },
  );
};
/**
 * 组件平移
 * @param component
 * @param offset
 */
export const translateComponent = (component, offset) => {
  let { offsetX, offsetY } = offset;
  component.css[ShapeConstants.x] += offsetX;
  component.css[ShapeConstants.y] += offsetY;
  //平移子组件
  if (size(component.children) > 0) {
    component.children.forEach(child => {
      translateComponent(child, offset);
    });
  }
};


/**
 * 将组好的web-component树状结构打平成最终的数组
 * @param tree
 * @param list
 */
export const parseWebComponentTree = (tree, list) => {
  for (let component of tree) {
    let componentCopy =_cloneDeep(component);
    componentCopy.children = componentCopy.children.map(item => {
      return { prop: item.prop };
    });
    list.push(componentCopy);
    if (component.children && component.children.length > 0) {
      parseWebComponentTree(component.children, list);
    }
  }
};

export const addViewTreeNode = (componentTree, templateProp, resultObject, parent?, parentDef?) => {
  let tree = [];
  for (let component of componentTree) {
    addViewNode(component, parent, parentDef, tree, templateProp, resultObject);
  }
  return tree;
};


/**
 * 初始化节点内容或节点的子节点
 * @param component
 * @param parent
 * @param parentDef
 * @param tree
 * @param templateProp
 * @param resultObject
 * @private
 */
export const addViewNode = (component, parent, parentDef, tree, templateProp, resultObject) => {
  //记录原始的组件坐标
  let componentDef =_cloneDeep(component);
  initNodeDataIndex(component, parent);
  if (component.prop === templateProp) {
    const filteredArray = parent.children.filter(item => {
      return item.prop.includes(templateProp);
    });
    let componentCopy = addViewTemplateCopy(component, componentDef, parent, parentDef, filteredArray.length, templateProp);
    // 忽略掉静态模板配置隐藏属性
    componentCopy.attrs.display.value = false;
    Object.keys(componentCopy.children[0].attrs).forEach(attr => {
      if (resultObject.hasOwnProperty(attr)) {
        componentCopy.children[0].attrs[attr].value = resultObject[attr];
      }
    });
    tree.push(componentCopy);
  } else {
    //遍历生成组件的子组件
    component.children = addViewTreeNode(component.children, templateProp, resultObject, component, componentDef);
    tree.push(component);
  }
};


export const addViewTemplateCopy = (component, componentDef, parent, parentDef, index, templateProp) => {
  let colNum = 1;
  let componentCopy =_cloneDeep(component);
  //重新生成循环区域组件实例坐标
  let col: number;
  let row: number;
  col = index % colNum;
  row = Math.floor(index / colNum);
  let offset = calOffset(parent, parentDef);
  calCyclicRegionPosition(componentCopy, component, col, row, offset);
  //生成uuid
  componentCopy.prop = componentDef.prop + PROP_SUFFIX_CONNECTOR + generateUUID();
  componentCopy.children.forEach(child => {
    child.parent = componentCopy.prop;
    child.prop = child.prop + PROP_SUFFIX_CONNECTOR + generateUUID();
  });
  //遍历生成循环区域的子组件
  componentCopy.children = addViewTreeNode(componentCopy.children, componentCopy, component, templateProp);
  return componentCopy;
};


/**
 * 自适应调整父节点宽高
 * @param node 节点
 * @param componentsConfig 节点配置
 * @param peer 节点的同级节点
 */
export const autoFitParentSize = (node, componentsConfig, peer?) => {
//是否自适应尺寸
  let autoSize = (node) => {
    return _get(node, 'attrs.containerAdapt.value') === 'auto';
  };

  if (node.children.length === 0 && !autoSize(node)) {
    return; // 没有子节点且固定宽高，不需要更新
  }

  if (node.children.length === 0 && autoSize(node) && FIT_AFTER_RENDER_COMPONENTS.includes(node.type)) {
    // 文本/富文本类型的组件渲染后才可能计算自适应宽高，初始化时不更新
    return;
  }

  let configNode = componentsConfig.components.find(item => { return node.prop.indexOf(item.prop) !== -1; });
  // 子节点的最大宽高
  let maxHeight = configNode.css[ShapeConstants.height];
  let maxWidth = configNode.css[ShapeConstants.width];

  for (const child of node.children) {
    if (!child.attrs['display'].value && (child.children.length > 0 || autoSize(child))) {
      autoFitParentSize(child, componentsConfig, node.children); // 递归更新子节点的尺寸
    }
    // if (!child.attrs['display'].value) {
    //   maxHeight = Math.max(maxHeight, child.css[ShapeConstants.y] + child.css[ShapeConstants.height] - node.css[ShapeConstants.y]);
    //   maxWidth = Math.max(maxWidth, child.css[ShapeConstants.x] + child.css[ShapeConstants.width] - node.css[ShapeConstants.x]);
    // }
    maxHeight = Math.max(maxHeight, child.css[ShapeConstants.y] + child.css[ShapeConstants.height] - node.css[ShapeConstants.y]);
    maxWidth = Math.max(maxWidth, child.css[ShapeConstants.x] + child.css[ShapeConstants.width] - node.css[ShapeConstants.x]);
  }

// 子节点的最大宽高与父节点的设计尺寸之差
  let heightDiff = maxHeight - node.css[ShapeConstants.height];
  let widthDiff = maxWidth - node.css[ShapeConstants.width];
  // 父节点下方的组件
  let downComponents = [];
  // 父节点右侧的组件
  let rightComponents = [];

  if (size(peer) > 0) {
    //筛选出设计稿中当前节点下方的组件以及当前节点下方的循环区域
    downComponents = peer.filter(item => {
      let configItem = componentsConfig.components.find(comp => {
        return item.prop.indexOf(comp.prop) !== -1;
      });
      let configNode = componentsConfig.components.find(comp => {
        return node.prop.indexOf(comp.prop) !== -1;
      });
      return configItem.css[ShapeConstants.y] > configNode.css[ShapeConstants.y] + configNode.css[ShapeConstants.height] ||
        (configNode.type === 'cyclic-region' && configItem.prop === configNode.prop && item.css[ShapeConstants.y] >= node.css[ShapeConstants.y] + node.css[ShapeConstants.height])
        // ||
        // (configNode.type === 'tree-node' && configItem.prop === configNode.prop && item.css[ShapeConstants.y] >= node.css[ShapeConstants.y] + node.css[ShapeConstants.height]);
    });
    rightComponents = peer.filter(item => {
      let configItem = componentsConfig.components.find(comp => {
        return item.prop.indexOf(comp.prop) !== -1;
      });
      let configNode = componentsConfig.components.find(comp => {
        return node.prop.indexOf(comp.prop) !== -1;
      });
      return configItem.css[ShapeConstants.x] > configNode.css[ShapeConstants.x] + configNode.css[ShapeConstants.width] ||
        (configNode.type === 'cyclic-region' && configItem.prop === configNode.prop && item.css[ShapeConstants.x] >= node.css[ShapeConstants.x] + node.css[ShapeConstants.width]);
    });
  }
  // 调整父节点的高度
  if (maxHeight > node.css[ShapeConstants.height]) {
    if (autoSize(node)) {
      node.css[ShapeConstants.height] = Math.max(node.css[ShapeConstants.height], maxHeight);
    }
    //调整下方组件的位置
    downComponents.forEach(component => {
      translateComponent(component, { offsetX: 0, offsetY: heightDiff });
    });
  } else if (autoSize(node)) {
    node.css[ShapeConstants.height] = maxHeight;
    //调整下方组件的位置
    downComponents.forEach(component => {
      translateComponent(component, { offsetX: 0, offsetY: heightDiff });
    });
  }

  if (maxWidth > node.css[ShapeConstants.width]) {
    if (autoSize(node)) {
      //调整组件宽度
      node.css[ShapeConstants.width] = Math.max(node.css[ShapeConstants.width], maxWidth);
    }
    //调整右侧组件的位置
    rightComponents.forEach(component => {
      translateComponent(component, { offsetX: widthDiff, offsetY: 0 });
    });
  } else if (autoSize(node)) {
    node.css[ShapeConstants.width] = maxWidth;
    //调整右侧组件的位置
    rightComponents.forEach(component => {
      translateComponent(component, { offsetX: widthDiff, offsetY: 0 });
    });
  }

};


/**
 * @description: 渲染态- 合并树
 * @param {string} instanceId
 * @param components
 * @return {*}
 */
export function mergeRenderComponents(instanceTree, componentsMap) {
  return new Map([...instanceTree, ...componentsMap])
}

/**
 * 数组转成map结构
 * @param components
 * @returns
 */
export function arrayToMap(components) {
  let tree = new Map()
  for (let item of components) {
    tree.set(item.prop, item);
  }
  return tree;
}

// 递归获取自定义参数
export function recursionCustomParams(functionBody, customParamMap) {
  if (!customParamMap) {
    customParamMap = {};
  }
  if (!Array.isArray(functionBody)) return customParamMap;
  functionBody.forEach(item => {
    if (item.paramType && item.prop && !item.inParams && !item.functionBody && !item.body && !item.conditions) {
      customParamMap[item.prop] = item;
    }
    if (item.conditions && Array.isArray(item.conditions.inParams)) {
      recursionCustomParams(item.conditions.inParams, customParamMap);
    }
    if (Array.isArray(item.body)) {
      recursionCustomParams(item.body, customParamMap);
    }
    if (Array.isArray(item.functionBody)) {
      recursionCustomParams(item.functionBody, customParamMap);
    }
    if (Array.isArray(item.inParams)) {
      recursionCustomParams(item.inParams, customParamMap);
    }
  });
  return customParamMap;
}

/**
 * 判断是否为空纯对象 {}，数组、null、undefined 全部返回 false
 * @param {any} val
 * @returns {boolean}
 */
export function isEmptyObject(val) {
  // 1. 排除 null、非对象、数组
  if (val === null || typeof val !== 'object' || Array.isArray(val)) {
    return false;
  }
  // 2. 获取全部自身key（字符串key + Symbol key）
  return Reflect.ownKeys(val).length === 0;
}
